export default __webpack_public_path__ + "static/media/contact_banner.cac9e310.png";